import api, { authService } from './api';

const get = async (url, params, fallbackError) => {
  try {
    // The api client only adds the token when refreshing it, so pass it here like the other services do.
    const token = authService.getToken();
    if (!token) throw new Error('No authentication token');
    const response = await api.get(url, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { success: true, ...response.data };
  } catch (error) {
    return { success: false, error: error.response?.data?.detail || fallbackError };
  }
};

export const financeService = {
  getReportOptions: () => get('/finance/reports/options', {}, 'Failed to load report options'),
  getPivot: (params) => get('/finance/reports/pivot', params, 'Failed to run report'),
  getPivotRows: (params) => get('/finance/reports/pivot/rows', params, 'Failed to load report rows'),
  getEntityStatement: (params) => get(
    '/finance/reports/entity-statement',
    params,
    'Failed to load the Entity Year-End Statement',
  ),
  getPrepurchasedInventory: (params) => get(
    '/finance/reports/prepurchased-inventory',
    params,
    'Failed to load Prepurchased Inventory',
  ),
};
